import styled from 'styled-components';

export default {
    CommandContainer: styled.div.attrs({ className: 'command-container' })`
        width: 60%;
        display: flex;
        flex-direction: column;
        border: 1px solid gray;
        align-items: flex-start;
        padding: 15px;
        margin: 20px 10px;
        position: relative;
        max-width: 860px;
        text-align: left;
        &:before {
            content: "${props => props.label}";
            display: block;
            position: absolute;
            top: -11px;
            background: white;
            font-weight: 600;
            padding: 0 5px;
        }    
    `,
    CommandInteractionContainer: styled.div.attrs({ className: 'command-interaction-container' })`
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 1rem;
    `,
    CommandElementContainer: styled.div.attrs({ className: 'command-element-container' })`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 1rem;
    `,
    Label: styled.label.attrs({ className: 'command-label' })`
    `,
    LabelText: styled.div.attrs({ className: 'command-label-text' })`
    `,
};
